module.exports = "/lucky-balls/img/infobox/info_Box_011.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_011.png
// module id = 1076
// module chunks = 0